// pages/CampusOverview.jsx
import React from "react";
import {
  FaSchool,
  FaTree,
  FaBookOpen,
  FaFlask,
  FaDesktop,
  FaUsers,
  FaCheckCircle,
  FaShieldAlt,
  FaWifi,
  FaChalkboardTeacher,
} from "react-icons/fa";
const CampusOverview = () => {
  return (
    <section className="relative py-20 px-4 md:px-10 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-80 h-80 bg-orange-300/20 rounded-full blur-3xl -translate-x-32"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-red-300/20 rounded-full blur-3xl translate-x-32"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-5 py-2 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3 tracking-wide">
            Campus
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Campus{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Overview
            </span>
          </h1>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-sm md:text-base leading-7">
            A thoughtfully designed campus that blends academics, activities and environment to ensure complete development of every student.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-10 items-start">
          <div className="relative bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-8 text-white shadow-2xl">
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/10 rounded-full blur-2xl"></div>
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center text-2xl mb-5">
              <FaSchool />
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold mb-4 leading-snug">
              Smart Campus For Smart Learning
            </h2>
            <p className="text-white/90 text-sm leading-7 mb-6">
              Our campus is built to inspire students through a balanced environment where learning, creativity and discipline go hand in hand.
            </p>
            <p className="text-white/80 text-sm leading-7 mb-8">
              From well-structured classrooms to open green spaces, every part of our campus supports both academic excellence and personal growth.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {[
                ["3 Acres", "Campus Area"],
                ["90+", "Classrooms"],
                ["Wi-Fi", "Enabled"],
                ["100%", "Safe Campus"],
              ].map(([title, sub], i) => (
                <div
                  key={i}
                  className="bg-white/15 border border-white/20 rounded-xl p-4 text-center"
                >
                  <h3 className="text-lg font-bold">{title}</h3>
                  <p className="text-[11px] text-white/80 mt-1">{sub}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="space-y-8">
            <div className="bg-white rounded-[26px] p-6 shadow-lg border border-orange-100">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Campus Highlights
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {[
                  "Spacious green environment",
                  "Ventilated classrooms",
                  "Modern infrastructure",
                  "Library & science labs",
                  "Student friendly campus",
                  "Activity & sports areas",
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-2 bg-orange-50 rounded-lg px-4 py-3"
                  >
                    <FaCheckCircle className="text-red-500 text-sm" />
                    <span className="text-sm font-medium text-gray-700">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Facilities
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {[
                  ["Classrooms", <FaSchool />, "Spacious and comfortable learning spaces"],
                  ["Library", <FaBookOpen />, "Encouraging reading & knowledge"],
                  ["Science Labs", <FaFlask />, "Hands-on practical learning"],
                  ["ICT Lab", <FaDesktop />, "Digital & smart education"],
                ].map(([title, icon, desc], i) => (
                  <div
                    key={i}
                    className="bg-white rounded-[20px] p-5 shadow-md border border-orange-100 hover:-translate-y-1 transition"
                  >
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-red-600 to-orange-500 text-white flex items-center justify-center mb-3">
                      {icon}
                    </div>

                    <h4 className="text-sm font-bold text-gray-900">
                      {title}
                    </h4>

                    <p className="text-xs text-gray-600 mt-1 leading-5">
                      {desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* Bottom Text */}
        <div className="mt-12 bg-white rounded-[26px] p-6 md:p-8 shadow-lg border border-orange-100 text-center">
          <p className="text-gray-600 text-sm md:text-base leading-7 max-w-3xl mx-auto">
            Our campus is designed to nurture young minds by combining academic excellence, modern facilities and a positive environment where students can explore their full potential and grow into confident individuals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CampusOverview;